import moment from 'moment';
import { format } from 'd3-format';
import { compose } from 'ramda';

import {
  groupByCampaign,
  averageLinesMapping,
} from '../ThirdPartyReports.helper';

const getX = ({ transactionDate }: any) =>
  moment.utc(transactionDate, 'YYYY-MM-DD');

const tickFormatYAxis = (value: number) => format('.1%')(value / 100);

const getVisitorShareMetrics = (groupedMetrics: { [key: string]: unknown[] }) =>
  compose(
    groupByCampaign,
    averageLinesMapping(groupedMetrics, 'avgVisitorShare', 'visitorShare'),
  ) as any;

const timesliceOptions = [
  {
    key: 'Daily',
    text: 'Daily',
    value: 'DAILY',
  },
  {
    key: 'Weekly',
    text: 'Weekly',
    value: 'WEEKLY',
  },
  {
    key: 'Monthly',
    text: 'Monthly',
    value: 'MONTHLY',
  },
];

export { getX, tickFormatYAxis, timesliceOptions, getVisitorShareMetrics };
